const carMakes = [
  {
    id: "alfaromeo",
    name: "Alfa Romeo",
    sampleCode: "917",
    models: [
      { model: "BRERA, MITO, GTV, SPIDER, GIULIETTA", year: "All", location: "On the engine compartment cover" },
      { model: "159, 147, MI.TO", year: "All", location: "On the tailgate of luggage compartment" },
    ]
  },
  {
    id: "audi",
    name: "Audi",
    sampleCode: "LZ75, LZ5W",
    models: [
      { model: "All", year: "Current", location: "Boot, under the carpet on a sticker near the spare wheel well" },
      { model: "All", year: "Current", location: "Boot, on the spare wheel well" },
      { model: "All", year: "Current", location: "Logbook within the glovebox" }
    ]
  },
  {
    id: "bmw",
    name: "BMW",
    sampleCode: "C09, A08/7",
    models: [
      { model: "1, 3, 5, 6, 7", year: "Current", location: "On the column/post driver side door" },
      { model: "X3, X5, Z4", year: "Current", location: "Inside the engine compartment" },
    ]
  },
  {
    id: "cadillac",
    name: "Cadillac",
    sampleCode: "U8554",
    models: [
      { model: "All", year: "All", location: "On service parts identification sticker" },
    ]
  },
  {
    id: "chevrolet",
    name: "Chevrolet",
    sampleCode: "GGE, 627D",
    models: [
      { model: "AVEO, CAPTIV, MATIZ, SPARK EPICA, LACETTI, NUBIRA KALOS, ORLANDO", year: "All", location: "Inside the engine compartment" },
      { model: "HRR", year: "All", location: "In the glove compartment" },
      { model: "All", year: "All", location: "Driver or passenger door shut" },
    ]
  },
  {
    id: "chrysler",
    name: "Chrysler",
    sampleCode: "PS2",
    models: [
      { model: "NEON, SEBRING, STRATUS CABRIO, VOYAGER", year: "All", location: "Inside the engine compartment" },
      { model: "PT CRUISER", year: "All", location: "On the inside of the front bumper" },
      { model: "CHEROKE", year: "All", location: "On the inside of the rear bumper" }
    ]
  },
  {
    id: "citroen",
    name: "Citroën",
    sampleCode: "EKQD",
    models: [
      { model: "C-CROSSER, NEMO, JUMPER", year: "All", location: "Inside the engine compartment" },
      { model: "C2, C3, C3, C4, C5, C8 PLURIEL, C3 PICASSO, C4 PICASSO, DS3, JUMPY", year: "All", location: "On the column/post of driver/passenger door" },
      { model: "C1", year: "All", location: "Inside of column, right side door" }
    ]
  },
  {
    id: "dacia",
    name: "Dacia",
    sampleCode: "RPK",
    models: [
      { model: "All", year: "Current", location: "Inside of driver/passenger door shut" },
    ]
  },
  {
    id: "daewoo",
    name: "Daewoo",
    sampleCode: "95U",
    models: [
      { model: "All", year: "All", location: "Inside the engine compartment" },
    ]
  },

  {
    id: "daihatsu",
    name: "Daihatsu",
    sampleCode: "S33",
    models: [
      { model: "CUORE, MATERIA, TERIOS, YRV SIRION, OPEN", year: "All", location: "Inside the engine compartment" },
    ]
  },
  {
    id: "ferrari",
    name: "Ferrari",
    sampleCode: "70, 910, 302",
    models: [
      { model: "All", year: "All", location: "Inside the engine compartment (under bonnet)" },
    ]
  },
  {
    id: "fiat",
    name: "Fiat",
    sampleCode: "270/A",
    models: [
      { model: "BRAVO, CROMA, PUNTO", year: "All", location: "On the engine compartment cover (under bonnet)" },
      { model: "DOBLO, DUCATO, SCUDO, QUBO, SEDICI, IDEA", year: "All", location: "Inside the engine compartment" },
      { model: "STILO, 500, 600, PANDA, MULTIPLA, GRANDE PUNTO", year: "All", location: "Inside the rear/luggage compartment" },
      { model: "NUOVO SCUDO, ULYSSE", year: "All", location: "On the driver side door edge" },
      { model: "NUOVO SCUDO, ULYSSE, SEDICI, STRADA", year: "All", location: "On the inside edge of passenger side door" }
    ]
  },
  {
    id: "ford",
    name: "Ford",
    sampleCode: "08, B, V5",
    models: [
      { model: "All", year: "2002-", location: "On the inside of the driver/passenger door column" },
      { model: "B-Max", year: "2013-", location: "Rear door shut" },
      { model: "KA+", year: "2016-", location: "Inside engine bay on the right side bumper on a sticker" }
    ]
  },
  {
    id: "honda",
    name: "Honda",
    sampleCode: "NH830M, R81",
    models: [
      { model: "ACCORD, JAZZ, CRV, FRV, S2000 , STREAM, CIVIC", year: "Current", location: "Inside the engine compartment" },
      { model: "CIVIC, INSIGHT, LOGO, S2000, NSX", year: "Current", location: "On the column/post driver side door" },
    ]
  },
  {
    id: "hummer",
    name: "Hummer",
    sampleCode: "U 8624",
    models: [
      { model: "All", year: "All", location: "Inside the glove compartment" },
    ]
  },
  {
    id: "hyundai",
    name: "Hyundai",
    sampleCode: "V5N, VV, T8T",
    models: [
      { model: "ACCENT, ATOS PRIME, COUPE', LANTRA, TRAJET, TERRACAN, SONICA", year: "All", location: "Inside the engine compartment" },
      { model: "i10, i30, iX35, iX55, SANTA FE, TUCSON, MATRIX", year: "All", location: "On the column/post driver side" },
      { model: "i20", year: "All", location: "On the edge of driver side door" }
    ]
  },
  {
    id: "isuzu",
    name: "Isuzu",
    sampleCode: "529",
    models: [
      { model: "All", year: "All", location: "Right hand side of engine bay" },
    ]
  },
  {
    id: "jaguar",
    name: "Jaguar",
    sampleCode: "PED",
    models: [
      { model: "XJ", year: "All", location: "Inside the engine compartment" },
      { model: "X TYPE, S TYPE, XJ, XF, XK", year: "All", location: "On the column/post driver side door" },
    ]
  },
  {
    id: "jeep",
    name: "Jeep",
    sampleCode: "GBS",
    models: [
      { model: "COMMANDER, COMPASS, LIBERTY, PATRIOT", year: "All", location: "On the front door column" },
      { model: "CHEROKEE, COMANCHE, GRAND CHEROKEE, WAGONEER", year: "All", location: "Inside the engine compartment" },
      { model: "WRANGLER", year: "All", location: "Under the front seat" }
    ]
  },
  {
    id: "kia",
    name: "Kia",
    sampleCode: "B3, IM, Y1",
    models: [
      { model: "CARNIVAL, CARENS, SORENTO, SPORTAGE, SOUL", year: "All", location: "Inside the engine compartment" },
      { model: "SOUL", year: "All", location: "On the inside column right side door" },
      { model: "CARNIVAL, CEE'D, PICANTO, RIO, SPORTAGE, VENGA", year: "All", location: "On the column/post driver side door" }
    ]
  },
  {
    id: "lamborghini",
    name: "Lamborghini",
    sampleCode: "LY9B, LZ3F",
    models: [
      { model: "All", year: "Current", location: "Inside the engine compartment" }
    ]
  },
  {
    id: "lancia",
    name: "Lancia",
    sampleCode: "270/A, 295",
    models: [
      { model: "DELTA, MUSA", year: "All", location: "Inside the engine compartment cover" },
      { model: "Y", year: "All", location: "Inside the luggage compartment" },
      { model: "PHEDRA", year: "All", location: "On edge of driver’s side door" }
    ]
  },
  {
    id: "landrangerover",
    name: "Land/Range Rover",
    sampleCode: "820, 912",
    models: [
      { model: "RANGE ROVER, RANGE ROVER SPORT, DISCOVERY", year: "Current", location: "Inside the engine compartment cover" },
      { model: "FREELANDER", year: "Current", location: "On the column of driver side door" },
    ]
  },
  {
    id: "lexus",
    name: "Lexus",
    sampleCode: "217",
    models: [
      { model: "All", year: "Current", location: "On the front door column" },
    ]
  },
  {
    id: "maserati",
    name: "Maserati",
    sampleCode: "NERO VR. 820/A",
    models: [
      { model: "All", year: "All", location: "Inside the engine compartment (under bonnet)" },
    ]
  },
  {
    id: "mazda",
    name: "Mazda",
    sampleCode: "A4A, 16W",
    models: [
      { model: "All", year: "Pre 1997", location: "Driver or passenger door shut" },
      { model: "All", year: "Post 1997", location: "Inside the engine compartment" },
      { model: "All", year: "Current", location: "Inside wing mirror cover" }
    ]
  },
  {
    id: "mercedes",
    name: "Mercedes",
    sampleCode: "799, C368",
    models: [
      { model: "All", year: "All", location: "Driver or passenger door shut" },
    ]
  },
  {
    id: "mini",
    name: "Mini",
    sampleCode: "C1B/2, 668/9, 901/6",
    models: [
      { model: "All", year: "Pre 2007", location: "Inside the engine compartment" },
      { model: "All", year: "Post 2007", location: "On the passenger side door column" },
    ]
  },
  {
    id: "mitsubishi",
    name: "Mitsubishi",
    sampleCode: "X42, W83, A31",
    models: [
      { model: "ASX, COLT, LANCER, OUTLANDER, PAJERO, L200, PAJERO PININ, SHOGUN", year: "All", location: "Inside the engine compartment" },
      { model: "COLT, COLT CZC, CANTER", year: "All", location: "On the passenger side door column" },
    ]
  },
  {
    id: "nissan",
    name: "Nissan",
    sampleCode: "RBN, BW9, KAD",
    models: [
      { model: "All", year: "All", location: "Driver or passenger door shut" },
      { model: "PATHFINDER, X-TRAIL, PATROL", year: "All", location: "Inside the engine compartment" },
      { model: "X-TRAIL", year: "All", location: "Passenger side corner nearest the windscreen" },
    ]
  },
  {
    id: "opel",
    name: "Opel",
    sampleCode: "Z 291, Z 163, ERD",
    models: [
      { model: "AGILA, ASTRA, CORSA, INSIGNA, VECTRA, ZAFIRA", year: "All", location: "On the column/post driver/passenger side door" },
      { model: "ANTARA, CORSA, MERIVA, SIGNUM", year: "All", location: "Inside the engine compartment" },
      { model: "MERIVA", year: "All", location: "Rear door shut" },
    ]
  },
  {
    id: "peugeot",
    name: "Peugeot",
    sampleCode: "KTP, EXYB",
    models: [
      { model: "All", year: "All", location: "On the driver side door edge" },
    ]
  },
  {
    id: "porsche",
    name: "Porsche",
    sampleCode: "C9Z, LATW",
    models: [
      { model: "All (except CAYENNE)", year: "All", location: "On the driver side door edge" },
      { model: "CAYENNE", year: "All", location: "Inside the boot" },
    ]
  },
  {
    id: "renault",
    name: "Renault",
    sampleCode: "TEHNK, TEA19, NV676",
    models: [
      { model: "All", year: "All", location: "On the passenger side door column" },
    ]
  },
  {
    id: "saab",
    name: "Saab",
    sampleCode: "170, 257",
    models: [
      { model: "All (except 9-5)", year: "All", location: "In the glove compartment" },
      { model: "9-5", year: "All", location: "On the drivers door shut/column" },
    ]
  },
  {
    id: "seat",
    name: "Seat",
    sampleCode: "Z9Y, LZ5W, LS7N",
    models: [
      { model: "All", year: "All", location: "Boot, under the carpet on a sticker near the spare wheel well" },
      { model: "ALAHMBRA", year: "All", location: "Rear storage space (left hand side)" },
    ]
  },
  {
    id: "skoda",
    name: "Skoda",
    sampleCode: "LF3X, 9893",
    models: [
      { model: "All", year: "All", location: "Boot, under the carpet on a sticker near the spare wheel well" },
    ]
  },
  {
    id: "smart",
    name: "Smart",
    sampleCode: "EB2 EA4",
    models: [
      { model: "FORTWO", year: "Old Model", location: "Inside the engine compartment (rear)" },
      { model: "FORTWO, FORFOUR", year: "All", location: "On the passenger side door column" },
    ]
  },
  {
    id: "ssangyong",
    name: "Ssangyong",
    sampleCode: "SAB",
    models: [
      { model: "KORANDO, MUSSO, REXTON", year: "All", location: "Inside the engine compartment" },
      { model: "ACTYON, KYRON, REXTON 2, RODIUS", year: "All", location: "On the driver side door column" },
    ]
  },
  {
    id: "subaru",
    name: "Subaru",
    sampleCode: "86F, H5Q, C1F",
    models: [
      { model: "All", year: "All", location: "On the column/post driver/passenger side door" },
    ]
  },
  {
    id: "suzuki",
    name: "Suzuki",
    sampleCode: "ZUM C08, ZFT C10, Z2S C03",
    models: [
      { model: "All", year: "All", location: "On the column/post driver/passenger side door" },
      { model: "JIMNY, VAGON, R SX4, GRAN VITARA", year: "All", location: "Inside the engine compartment (left hand side)" },
    ]
  },
  {
    id: "tesla",
    name: "Tesla",
    sampleCode: "PMNG",
    models: [
      { model: "All", year: "All", location: "On the column/post driver/passenger side door" },
    ]
  },
  {
    id: "toyota",
    name: "Toyota",
    sampleCode: "791, 6T3",
    models: [
      { model: "All", year: "All", location: "On the column/post driver/passenger side door" },
      { model: "RAV4, AVENSIS, YARIS, VERSO, HILUX, HIACE, LAND CRUISER", year: "All", location: "Inside the engine compartment" },
    ]
  },
  {
    id: "vauxhall",
    name: "Vauxhall",
    sampleCode: "Z 291, Z 163, ERD",
    models: [
      { model: "AGILA, ASTRA, CORSA, INSIGNA, VECTRA, ZAFIRA", year: "All", location: "On the column/post driver/passenger side door" },
      { model: "ANTARA, CORSA, MERIVA, SIGNUM", year: "All", location: "Inside the engine compartment" },
      { model: "MERIVA", year: "All", location: "Rear door shut" },
    ]
  },
  {
    id: "volkswagen",
    name: "Volkswagen",
    sampleCode: "LC9Z, LD3V",
    models: [
      { model: "All", year: "Current", location: "Boot, under the carpet on a sticker near the spare wheel well" },
      { model: "All", year: "Current", location: "Boot, on the spare wheel well" },
      { model: "All", year: "Current", location: "Logbook within the glovebox" }
    ]
  },
  {
    id: "volvo",
    name: "Volvo",
    sampleCode: "476-18, 426-26",
    models: [
      { model: "XC90, C70, S40, S60, S70, S80, V40, V70", year: "All", location: "Inside the engine compartment" },
      { model: "C30, S40, V50, XC70, V40, XC40, XC60, V60", year: "All", location: "On the column/post driver/passenger side door" },
    ]
  }
];

function printColourCodeInfo(event) {
  const selectedMake = event.target.value;
  let nameHTML = "";
  let tableHTML = "";
  let imageHTML = ""
  let codeHTML = ""

  if (selectedMake != "none") {
    const make = carMakes.find(make => make.id === selectedMake);

    nameHTML = `<h6>${make.name}</h6>`;

    tableHTML = '<table class="model-table"><tr><th>Model</th><th>Year</th><th>Location</th></tr>';

    make.models.forEach(model => {
      tableHTML += '<tr>';
      Object.values(model).forEach(value => {
        tableHTML += `<td>${value}</td>`;
      });
      tableHTML += '</tr>';
    });

    tableHTML += '</table>';
    imageHTML = `<img src=https://cdn.shopify.com/s/files/1/0830/0183/5843/files/colour-code-${make.id}.png />`;
    codeHTML = make.sampleCode ? `Sample Code: <span class="sample-code-code">${make.sampleCode}</span>` : "";
  }

  let manufacturerName = document.getElementById('manufacturer-name');
  manufacturerName.innerHTML = nameHTML;
  let modelTable = document.getElementById('model-table');
  modelTable.innerHTML = tableHTML;
  let sampleCode = document.getElementById('sample-code');
  sampleCode.innerHTML = codeHTML;
  let codeImage = document.getElementById('code-image');
  codeImage.innerHTML = imageHTML;
}